module.exports = __webpack_public_path__ + "static/media/first-workshop@2x.68135e23.png";